module.exports = function (fox) {
	"use strict";

	require('fox-dynamic-injection!fox-template-loader!./templates.tpl')(fox);
	require('./widget/notificationsManager.js')(fox);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-notifications-settings/index.js
// module id = 581
// module chunks = 4